import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAmenity,
  getCityList,
  getConfiguration,
  getPropertyType,
} from "reduxStore/action/masterActions";
import Select from "react-select";
import {
  continueSameProperty,
  propertyCheckAction,
  propertyForm,
} from "reduxStore/action/propertyActions";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import strings from "translate/language";
import {
  handleListResponse,
  seo,
  minORmaxAmountValid,
  isEmpty,
  emailAddressValid,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";

const AddNewProperty = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [selectFields, setSelectFields] = useState([
    {
      configuration_id: "",
      configuration_title: "4bhk",
      area: "",
      max_rate: "",
      min_rate: "",
      max_rate_type: "",
      min_rate_type: "",
      inventry: "",
      sold_out: 0,
      remaining: "",
    },
  ]);
  const [formState, setFormState] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [propretyType, setPropertyType] = useState([]);
  const [allocationAddMore, setAllocationAddMore] = useState(true);
  const [isPropertyNameExits, setIsPropertyNameExits] = useState(false);
  const [configurationsType, setConfigurationsType] = useState([]);
  const [amenitiesOption, setAmenitiesOption] = useState([]);
  const propertyFormSelector = useSelector((state) => state.propertyForm);
  const propertyDataSelector = useSelector((state) => state.propertyData);
  const propertyTypesSelector = useSelector((state) => state.propertyTypes);
  const configurationsSelector = useSelector((state) => state.configurations);
  const amenitiesSelector = useSelector((state) => state.amenities);
  const GetCityListSelector =
    useSelector((state) => state.cityMasterData?.response?.data) || [];
  useEffect(() => {
    if (!propertyFormSelector.update && propertyFormSelector?.response) {
      setFormState(propertyFormSelector?.response);
      if (propertyFormSelector?.response?.configuration_area) {
        setSelectFields(propertyFormSelector?.response?.configuration_area);
      }
    }
  }, [propertyFormSelector]);
  const handleConfirm = () => {
    formState.configuration_area = selectFields;
    dispatch(continueSameProperty());
    dispatch(propertyForm(formState));
    navigatpage("/addnewpropertynext");
  };
  useEffect(() => {
    const { propertyCheckresponse } = propertyDataSelector;
    if (propertyCheckresponse && propertyCheckresponse.status === 200) {
      handleConfirm();
    } else if (propertyCheckresponse && propertyCheckresponse.status === 201) {
      setIsPropertyNameExits(true);
    }
  }, [propertyDataSelector]);
  useLayoutEffect(() => {
    if (propertyFormSelector.update) {
      dispatch(propertyForm(null));
    }
    dispatch(getAmenity());
    dispatch(getConfiguration());
    dispatch(getPropertyType());
  }, [dispatch]);

  // Field_Disable
  useEffect(() => {
    if (selectFields) {
      if (
        selectFields[0].inventry.length === 0 ||
        !selectFields[0].configuration_id
      ) {
        setAllocationAddMore(true);
      } else {
        if (
          selectFields.some(
            (i) => i.inventry.length === 0 || i.configuration_id === ""
          )
        ) {
          setAllocationAddMore(true);
        } else if (
          selectFields.some(
            (i) => i.inventry.length === 1 || i.configuration_id != ""
          )
        ) {
          setAllocationAddMore(false);
        }
      }
    }
  }, [selectFields]);

  // Field_Disable

  useEffect(() => {
    if (propertyTypesSelector.response) {
      const { response } = propertyTypesSelector;
      if (response?.status === 200) {
        setPropertyType(handleListResponse(response.data));
      } else {
        setPropertyType([]);
      }
    }
  }, [propertyTypesSelector]);

  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        setConfigurationsType(handleListResponse(response.data));
      } else {
        setConfigurationsType([]);
      }
    }
  }, [configurationsSelector]);

  useEffect(() => {
    if (amenitiesSelector.response) {
      const { response } = amenitiesSelector;
      if (response?.status === 200) {
        setAmenitiesOption(handleListResponse(response.data));
      } else {
        setAmenitiesOption([]);
      }
    }
  }, [amenitiesSelector]);
  useEffect(() => {
    dispatch(getCityList());
  }, [dispatch]);

  const handleChange = (index, event) => {
    let data = [...selectFields];
    if (event.target.name == "inventry") {
      data[index]["remaining"] = event.target.value;
    }
    data[index][event.target.name] = event.target.value;

    if (event.target.name == "configuration_id") {
      const datas = configurationsType.find(
        (e) => e._id === event.target.value
      );
      data[index]["configuration_title"] = datas?.title;
      // const remdata = Number(event.target.value) - Number(data[index].sold_out);
      // data[index][event.target.name] = remdata;
    }

    setSelectFields(data);
  };
  const handleConfigAmount = (
    index,
    value,
    min_rate,
    max_rate,
    min_rate_type,
    max_rate_type
  ) => {
    const err = minORmaxAmountValid(
      min_rate,
      max_rate,
      min_rate_type,
      max_rate_type
    );
    if (value != "" && !err) {
      let data = [...selectFields];
      data[index]["amountErr"] = strings.amountEror;
      setSelectFields(data);
      setFormVaild({
        ...formVaild,
        amountErr: strings.amountEror,
      });
    } else {
      let data = [...selectFields];
      data[index]["amountErr"] = null;
      setSelectFields(data);
      setFormVaild({
        ...formVaild,
        amountErr: null,
      });
    }
  };
  const addSelectFields = () => {
    let newSelectField = {
      configuration_id: "",
      configuration_title: "4bhk",
      area: "",
      max_rate: "",
      min_rate: "",
      max_rate_type: "",
      min_rate_type: "",
      inventry: "",
      sold_out: 0,
      remaining: "",
    };
    setAllocationAddMore(true);
    setSelectFields([...selectFields, newSelectField]);
  };
  const removeFields = (index) => {
    let data = [...selectFields];
    data.splice(index, 1);
    setSelectFields(data);
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...formState,
      [e.target.name]: e.target.value,
    };
    let err = formVaild;
    err[e.target.name] = null;
    setFormVaild(err);
    setFormState(nextFormState);
  };
  const handleInputPlaces = (e) => {
    const nextFormState = {
      ...formState,
      area: e,
      latitude: "",
      longitude: "",
    };
    setFormState(nextFormState);
  };
  const handleSelect = (latLng, area) => {
    const nextFormState = {
      ...formState,
      area: area,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setFormState(nextFormState);
  };
  const handleSelectMulti = (value) => {
    setFormState({
      ...formState,
      amenity: value,
    });
  };

  const handleNext = () => {
    if (!handleValid()) {
      delete formState.cityObj;
      dispatch(
        propertyCheckAction({ property_title: formState?.property_title })
      );
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!formState.property_title) {
      formError = true;
      err["property_title"] = strings.property_titleErr;
    }
    if (!formState.location) {
      formError = true;
      err["location"] = strings.locationErr;
    }

    if (!formState.city) {
      formError = true;
      err["city"] = strings.cityErr;
    }
    if (!formState.area) {
      formError = true;
      err["area"] = strings.locationAreaErr;
    }
    // 09-05-2024
    // else if (!formState.longitude) {
    //   formError = true;
    //   err["area"] = strings.validLocationErr;
    // } else if (formState.longitude === "undefined") {
    //   formError = true;
    //   err["area"] = strings.validLocationErr;
    // }
    // 09-05-2024
    if (!formState.start_date) {
      formError = true;
      err["start_date"] = strings.startDateErr;
    }
    if (!formState.end_date) {
      formError = true;
      err["end_date"] = strings.endDateErr;
    }
    if (!formState.property_type) {
      formError = true;
      err["property_type"] = strings.typeOfPropertyErr;
    }
    if (!formState.crm_person_email) {
      formError = true;
      err["crm_person_email"] = strings.emailErr;
    } else if (!emailAddressValid(formState.crm_person_email)) {
      formError = true;
      err["crm_person_email"] = strings.emailValidationErr;
    }
    if (!formState.jw_project_id) {
      formError = true;
      err["jw_project_id"] = strings.jwIDErr;
    }
    if (selectFields[0].configuration_id === "") {
      formError = true;
      err["configuration_id"] = strings.configurationErr;
    }
    // if (selectFields[0].area === "") {
    //   formError = true;
    //   err["area_conf"] = strings.areaconfErr;
    // } else if (isNaN(selectFields[0].area)) {
    //   formError = true;
    //   err["area_conf"] = strings.areain_sqlft_Nan_Err;
    // }
    // if (selectFields[0].min_rate === "") {
    //   formError = true;
    //   err["min_rate"] = strings.minErr;
    // } else if (isNaN(selectFields[0].min_rate)) {
    //   formError = true;
    //   err["min_rate"] = strings.budget_Err;
    // }
    // if (selectFields[0].min_rate_type === "") {
    //   formError = true;
    //   err["min_rate_type"] = strings.minErr;
    // }

    // if (selectFields[0].max_rate === "") {
    //   formError = true;
    //   err["max_rate"] = strings.maxErr;
    // } else if (isNaN(selectFields[0].max_rate)) {
    //   formError = true;
    //   err["max_rate"] = strings.budget_Err;
    // }
    // if (selectFields[0].max_rate_type === "") {
    //   formError = true;
    //   err["max_rate_type"] = strings.minErr;
    // }
    // if (
    //   selectFields[0].min_rate &&
    //   selectFields[0].max_rate &&
    //   (!selectFields[0].min_rate_type || !selectFields[0].max_rate_type)
    // ) {
    //   formError = true;
    //   err["amountErr"] = strings.amountTypeErr;
    // }
    // if (
    //   !minORmaxAmountValid(
    //     selectFields[0].min_rate,
    //     selectFields[0].max_rate,
    //     selectFields[0].min_rate_type,
    //     selectFields[0].max_rate_type
    //   )
    // ) {
    //   formError = true;
    //   err["amountErr"] = strings.amountEror;
    // }

    // if (selectFields[0].inventry === "") {
    //   formError = true;
    //   err["inventry"] = strings.inventryErr;
    // } else if (isNaN(selectFields[0].inventry)) {
    //   formError = true;
    //   err["inventry"] = strings.inventryError;
    // }
    if (!isEmpty(formVaild)) {
      formError = true;
    }

    setFormVaild(err);
    return formError;
  };

  // Disable end_date
  useEffect(() => {
    if (!formState.start_date) {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [formState.start_date]);

  useEffect(() => {
    seo({
      title: "Add New Property",
      metaDescription: "Add Property",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      {/* Model_start */}
      {isPropertyNameExits ? (
        <div
          className="modal show"
          tabIndex="-1"
          style={{
            display: "block",
          }}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {strings.property}
                </h5>
                <button
                  className="close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {/* <span aria-hidden="true">×</span> */}
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>{strings.propertyNameExits}</h6>
                </div>
                <div className="text-center">
                  <h6>{strings.propertyNameExitsConfirm}</h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-success mr-5"
                  type="button"
                  onClick={() => {
                    setIsPropertyNameExits(false);
                    handleConfirm();
                  }}
                  data-dismiss="modal"
                >
                  {strings.yes}
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    dispatch(continueSameProperty());
                    setIsPropertyNameExits(false);
                  }}
                  data-dismiss="modal"
                >
                  {strings.no}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* Model_end */}
      <Breadcrumb
        title={strings.addnewproperty}
        url={"/property"}
        parentListing={strings.propertyListing}
        titleactive={strings.addNewProperty}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <form className="form theme-form">
              <div className="card">
                <div className="card-header pb-0">
                  <h5>{strings.addNewProperty}</h5>
                </div>
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.projectName}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          placeholder={strings.projectName}
                          name="property_title"
                          value={formState.property_title}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild.property_title && (
                          <span style={{ color: "red" }}>
                            {formVaild.property_title}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.city}
                          <span className="required-field"></span>
                        </label>
                        <Select
                          isSearchable
                          options={GetCityListSelector}
                          getOptionLabel={(option) => `${option.city_name}`}
                          getOptionValue={(option) => option.city_id}
                          name="cityObj"
                          value={formState.cityObj}
                          onChange={(val) => {
                            const nextFormState = {
                              ...formState,
                              cityObj: val,
                              city: val.city_name,
                              city_id: val.city_id,
                            };
                            setFormState(nextFormState);
                          }}
                        />
                        {formVaild.city && (
                          <span style={{ color: "red" }}>{formVaild.city}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.locality}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlLastName"
                          type="text"
                          placeholder={strings.locality}
                          name="location"
                          value={formState.location}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild.location && (
                          <span style={{ color: "red" }}>
                            {formVaild.location}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* 09-05-2024 */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlArea">
                          {strings.locationArea}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlArea"
                          type="text"
                          placeholder={strings.locationArea}
                          name="area"
                          value={formState.area}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild.area && (
                          <span style={{ color: "red" }}>
                            {formVaild.area}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* 09-05-2024 */}
                  {/* 09-05-2024 */}
                  {/* <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.locationArea}
                          <span className="required-field"></span>
                        </label>
                        <AutocompletePlace
                          placeholder={strings.locationArea}
                          value={formState.area}
                          onChange={handleInputPlaces}
                          onSelect={handleSelect}
                        />
                        {formVaild.area && (
                          <span style={{ color: "red" }}>{formVaild.area}</span>
                        )}
                      </div>
                    </div>
                  </div> */}
                  {/* 09-05-2024 */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.startDate}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="start_date"
                          value={formState.start_date}
                          onChange={handleInputField}
                        // min={formState.start_date}
                        />
                        {formVaild.start_date && (
                          <span style={{ color: "red" }}>
                            {formVaild.start_date}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.endDate}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="end_date"
                          value={formState.end_date}
                          onChange={handleInputField}
                          min={formState.start_date}
                          max={formState.end_date}
                          disabled={endDateDisable}
                          title="Please first select start date"
                        />
                        {formVaild.end_date && (
                          <span style={{ color: "red" }}>
                            {formVaild.end_date}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.typeOfProperty}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          id="exampleFormControlSelect9"
                          name="property_type"
                          value={formState.property_type}
                          onChange={handleInputField}
                        >
                          <option value="">
                            {strings.selectType}
                          </option>
                          {propretyType.length > 0 ? (
                            propretyType.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                        {formVaild.property_type && (
                          <span style={{ color: "red" }}>
                            {formVaild.property_type}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.amenity}({strings.optional})
                        </label>
                        <Select
                          isSearchable
                          isMulti
                          options={amenitiesOption || []}
                          getOptionLabel={(option) => option.title}
                          getOptionValue={(option) => option._id}
                          name="amenity"
                          value={formState.amenity}
                          onChange={handleSelectMulti}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.crmPersonEmail}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="email"
                          placeholder={strings.emailaddress}
                          name="crm_person_email"
                          value={formState.crm_person_email}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild.crm_person_email && (
                          <span style={{ color: "red" }}>
                            {formVaild.crm_person_email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.jqProjectID}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          placeholder={strings.jqProjectID}
                          name="jw_project_id"
                          value={formState.jw_project_id}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild.jw_project_id && (
                          <span style={{ color: "red" }}>
                            {formVaild.jw_project_id}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="card" >
                <div className="card-header pb-0">
                  <h6>{strings.selectconfiguration}</h6>
                </div>

                {selectFields &&
                  selectFields.map((select, index) => {
                    return (
                      <div className="row confi-add" key={index}>
                        <div className="col-md-8">
                          <div className="">
                            <label htmlFor="exampleFormControlSelect9">
                              {strings.configuration}
                              <span className="required-field"></span>
                            </label>
                            <select
                              className="form-control digits"
                              id="exampleFormControlSelect9"
                              name="configuration_id"
                              style={{
                                border:
                                  formVaild.configuration_id &&
                                    index === 0
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                              }}
                              value={select.configuration_id}
                              onChange={(event) =>
                                handleChange(index, event)
                              }
                            >
                              <option value="">
                                {strings.selectType}
                              </option>
                              {configurationsType.length > 0 ? (
                                configurationsType.map((item, i) => (
                                  <option
                                    key={i}
                                    value={item._id}
                                  >
                                    {item.title}
                                  </option>
                                ))
                              ) : (
                                <option>{strings.Loading}</option>
                              )}
                            </select>


                            {formVaild.configuration_id && (
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "10px",
                                  display: "flex",
                                }}
                              >
                                {formVaild.configuration_id}
                              </span>
                            )}
                          </div>

                        </div>
                        {index != 0 && (
                          <div className="col-md-1">
                            <Button
                              className="btn btn-danger btn-minus"
                              onClick={() => removeFields(index)}
                              label={"-"}
                            ></Button>
                          </div>
                        )}
                        <div className="col-md-1">
                          <Button
                            className="btn btn-success btn-plus"
                            onClick={() => addSelectFields()}
                            // disabled={allocationAddMore}
                            label={"+"}
                          ></Button>
                        </div>
                      </div>


                    );
                  })}
              </div>



              {/* <div className="col-sm-12">
                <div className="row">
                  {selectFields &&
                    selectFields.map((select, index) => {
                      return (
                        <div className="card" key={index}>
                          <div className="card-header pb-0">
                            <h6>{strings.selectconfiguration}</h6>
                          </div>
                          <div className="card-body">
                            <div className="col-md-12 row">
                              <div className="col-md-12 row">
                                <div className="col-md-4">
                                  <div className="mb-3">
                                    <label htmlFor="exampleFormControlSelect9">
                                      {strings.configuration}
                                      <span className="required-field"></span>
                                    </label>

                                    <select
                                      className="form-control digits"
                                      id="exampleFormControlSelect9"
                                      name="configuration_id"
                                      style={{
                                        border:
                                          formVaild.configuration_id &&
                                            index === 0
                                            ? "1px solid red"
                                            : "1px solid #ced4da",
                                      }}
                                      value={select.configuration_id}
                                      onChange={(event) =>
                                        handleChange(index, event)
                                      }
                                    >
                                      <option value="">
                                        {strings.selectType}
                                      </option>
                                      {configurationsType.length > 0 ? (
                                        configurationsType.map((item, i) => (
                                          <option
                                            key={i}
                                            value={item._id}
                                          >
                                            {item.title}
                                          </option>
                                        ))
                                      ) : (
                                        <option>{strings.Loading}</option>
                                      )}
                                    </select>
                                    {formVaild.configuration_id && (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "10px",
                                          display: "flex",
                                        }}
                                      >
                                        {formVaild.configuration_id}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="mb-3">
                                    <label htmlFor="exampleFormControlSelect9">
                                      {strings.Area}
                                      <span className="required-field"></span>
                                    </label>
                                    <input
                                      className="form-control"
                                      id="exampleFormControlInput1"
                                      autoComplete="off"
                                      type="number"
                                      name="area"
                                      style={{
                                        border:
                                          formVaild.area_conf && index === 0
                                            ? "1px solid red"
                                            : "1px solid #ced4da",
                                      }}
                                      value={select.area}
                                      onChange={(event) =>
                                        handleChange(index, event)
                                      }
                                      onKeyPress={(e) => {
                                        if (e.target.value.length >= 10) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {formVaild.area_conf && (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "10px",
                                          display: "flex",
                                        }}
                                      >
                                        {formVaild.area_conf}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12 row">
                                <div className="col-md-4">
                                  <div className="mb-3">
                                    <label htmlFor="exampleFormControlSelect9">
                                      {strings.min}
                                      <span className="required-field"></span>
                                    </label>
                                    <div className="d-flex flex-direction-row">
                                      <input
                                        className="form-control"
                                        id="exampleFormControlInput1"
                                        autoComplete="off"
                                        type="number"
                                        name="min_rate"
                                        style={{
                                          border:
                                            formVaild.min_rate && index === 0
                                              ? "1px solid red"
                                              : "1px solid #ced4da",
                                        }}
                                        value={select.min_rate}
                                        onChange={(event) => {
                                          handleChange(index, event);
                                          handleConfigAmount(
                                            index,
                                            event.target.value,
                                            event.target.value,
                                            select.max_rate,
                                            select.min_rate_type,
                                            select.max_rate_type
                                          );
                                        }}
                                        onKeyPress={(e) => {
                                          if (e.target.value.length >= 4) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      <select
                                        id="exampleFormControlSelect9"
                                        name="min_rate_type"
                                        value={select.min_rate_type}
                                        style={{
                                          border:
                                            formVaild.min_rate_type && index === 0
                                              ? "1px solid red"
                                              : "1px solid #ced4da",
                                        }}
                                        onChange={(event) => {
                                          handleChange(index, event);
                                          handleConfigAmount(
                                            index,
                                            event.target.value,
                                            select.min_rate,
                                            select.max_rate,
                                            event.target.value,
                                            select.max_rate_type
                                          );
                                        }}
                                      >
                                        <option value={""}>₹</option>
                                        <option value={"L"}>L</option>
                                        <option value={"C"}>Cr</option>
                                      </select>
                                    </div>
                                    {formVaild.min_rate && (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "9px",
                                          display: "flex",
                                        }}
                                      >
                                        {formVaild.min_rate}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="mb-3">
                                    <label htmlFor="exampleFormControlSelect9">
                                      {strings.max}
                                      <span className="required-field"></span>
                                    </label>
                                    <div className="d-flex flex-direction-row">
                                      <input
                                        className="form-control"
                                        id="exampleFormControlInput1"
                                        autoComplete="off"
                                        type="number"
                                        name="max_rate"
                                        value={select.max_rate}
                                        style={{
                                          border:
                                            formVaild.max_rate && index === 0
                                              ? "1px solid red"
                                              : "1px solid #ced4da",
                                        }}
                                        onChange={(event) => {
                                          handleChange(index, event);
                                          handleConfigAmount(
                                            index,
                                            event.target.value,
                                            select.min_rate,
                                            event.target.value,
                                            select.min_rate_type,
                                            select.max_rate_type
                                          );
                                        }}
                                        onKeyPress={(e) => {
                                          if (e.target.value.length >= 4) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      <select
                                        id="exampleFormControlSelect9"
                                        name="max_rate_type"
                                        value={select.max_rate_type}
                                        style={{
                                          border:
                                            formVaild.max_rate_type && index === 0
                                              ? "1px solid red"
                                              : "1px solid #ced4da",
                                        }}
                                        onChange={(event) => {
                                          handleChange(index, event);
                                          handleConfigAmount(
                                            index,
                                            event.target.value,
                                            select.min_rate,
                                            select.max_rate,
                                            select.min_rate_type,
                                            event.target.value
                                          );
                                        }}
                                      >
                                        <option value={""}>₹</option>
                                        <option value={"L"}>L</option>
                                        <option value={"C"}>Cr</option>
                                      </select>
                                    </div>
                                    {formVaild.max_rate && (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "9px",
                                          display: "flex",
                                        }}
                                      >
                                        {formVaild.max_rate}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                {select?.amountErr && (
                                  <div className="col-md-8 d-flex justify-content-center ">
                                    <span style={{ color: "red" }}>
                                      {select.amountErr}
                                    </span>
                                  </div>
                                )}
                              </div>

                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label htmlFor="exampleFormControlSelect9">
                                    {strings.inventry}
                                    <span className="required-field"></span>
                                  </label>
                                  <input
                                    className="form-control"
                                    id="exampleFormControlInput1"
                                    autoComplete="off"
                                    type="number"
                                    name="inventry"
                                    style={{
                                      border:
                                        formVaild.inventry && index === 0
                                          ? "1px solid red"
                                          : "1px solid #ced4da",
                                    }}
                                    value={select.inventry}
                                    onChange={(event) =>
                                      handleChange(index, event)
                                    }
                                  />
                                  {formVaild.inventry && (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        display: "flex",
                                      }}
                                    >
                                      {formVaild.inventry}
                                    </span>
                                  )}
                                </div>
                              </div>

                              {index != 0 && (
                                <div className="col-md-1">
                                  <Button
                                    className="btn btn-danger btn-minus"
                                    onClick={() => removeFields(index)}
                                    label={"-"}
                                  ></Button>
                                </div>
                              )}
                              <div className="col-md-1">
                                <Button
                                  className="btn btn-success btn-plus"
                                  onClick={() => addSelectFields()}
                                  // disabled={allocationAddMore}
                                  label={"+"}
                                ></Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div> */}


              <div className="row">
                <div className="col-md-12 d-flex justify-content-end">
                  <Button
                    className="btn btn-color"
                    onClick={() => handleNext()}
                    label={strings.next}
                  ></Button>
                </div>
              </div>
            </form>
          </div>
        </div >
      </div >
      {isPropertyNameExits && <div className="modal-backdrop fade show"></div>}
    </div >
  );
};
export default AddNewProperty;
